import SolutionIntegrationsI18n from "@/components/landing/shared/SolutionIntegrationsI18n";
const MarketingIntegrationsSection = () => <SolutionIntegrationsI18n translationPrefix="marketingSolution" />;
export default MarketingIntegrationsSection;
